import { disableLongPressBS, noTouchAction } from '../constants/Styles';
import { noteInteraction } from '../vodjs/Utils';

interface DRButtonProps {
  action: () => void;
  fontColor: string;
  fontSize?: number;
  borderColor: string;
  fillColor: string;
  phrase: string;
  height?: number | string;
  width?: number | string;
  disabled?: boolean;
  customizeStyle?: any;
  id?: string;
  style?:any;
}

export const DRButton = (props: DRButtonProps) => {
  const {
    action,
    fontColor,
    fontSize,
    borderColor,
    fillColor,
    phrase,
    disabled = false,
    customizeStyle = null,
    id = '',
  } = props;

  let { height, width } = props;

  if (Number(height) == height) height += 'px';
  if (Number(width) == width) width += 'px';

  let backgroundColor = fillColor || 'white';

  const style = {
    width: width || 436,
    height: height || 80,
    fontSize: fontSize || 36,
    backgroundColor,
    borderRadius: '40px',
    lineHeight: height, //to vertically align the text
    cursor: 'pointer',
    border: `5px solid ${borderColor}`,
    fontFamily: 'Open Sans',
    fontWeight: 700,
    color: fontColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? 0.4 : 1,
    ...props.style,
    ...disableLongPressBS,
  };

  return (
    <button
      id={id}
      style={{ ...style, ...(customizeStyle || {}) }}
      onClick={() => {
        noteInteraction();
        if (!disabled) {
          action();
        }
      }}
      disabled={disabled}
    >
      {phrase}
    </button>
  );
};

interface DRNoteInputProps {
  onChangeText: (text: string) => void;
  placeholderText: string;
  textInputStyle: any;
  value: string;
}

export const DRNoteInput = (props: DRNoteInputProps) => {
  const { onChangeText, placeholderText, textInputStyle, value } = props;

  return (
    <textarea
      style={{
        backgroundColor: '#ECECEC',
        padding: 16,
        resize: 'none',
        border: 'none',
        borderRadius: 6,
        fontSize: 20,
        fontFamily: 'Open Sans',
        ...textInputStyle,
        ...noTouchAction,
      }}
      placeholder={placeholderText ? placeholderText : 'Add notes here...'}
      onChange={(event) => {
        const text = event.target.value;
        onChangeText(text);
      }}
      value={value}
    />
  );
};

interface ErrorBannerProps {
  title: string;
  message: string;
  dismiss: () => void;
}

export const ErrorBanner = (props: ErrorBannerProps) => {
  const { title, message, dismiss } = props;
  return (
    <div
      onClick={()=> { noteInteraction(); dismiss();}}
      style={{
        position: 'absolute',
        bottom: 0,
        alignItems: 'center',
        backgroundColor: '#FF0000',
        padding: 10,
        width: '100%',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <div>{title}</div>
      <div>{message}</div>
    </div>
  );
};
